module.exports = __webpack_public_path__ + "static/img/app_mso.e960070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/app_mso.png
// module id = +feW
// module chunks = 8